module.exports = __webpack_public_path__ + "static/media/golfer-6-b.b9bc4c45.png";